<app-hero></app-hero>
<app-stats></app-stats>
<app-services></app-services>
<app-projects></app-projects>
<app-why-choose-us></app-why-choose-us>
<!-- <app-testimonials></app-testimonials> -->